import * as React from 'react';
import Icon from './Icon';
import * as topIllustrationPopup from '../assets/images/top-illustration-popup.svg';
import * as shield from '../assets/images/icon-shield.svg';
import * as school from '../assets/images/icon-school.svg';
import { t } from '../helper/locale';
import { ProtectionStatus } from '../protectionStatus';

declare const isDelegation: boolean;

export const ProtectionPopup: React.FunctionComponent<{
  params: { status: ProtectionStatus };
  location?: { query?: { organisation_name?: string } };
}> = ({ params, location }) => {
  const organisationName = location?.query?.organisation_name;
  const texts = getPopupTexts(params.status, organisationName);
  return (
    <div className="ProtectionPopup">
      <div className="illustrations-wrapper">
        <img className="top-illustration-simple" src={topIllustrationPopup} />
        <Icon
          data-testid="icon"
          className="top-illustration"
          path={getPopupIcon(params.status)}
        />
      </div>

      <h1 data-testid="title">{texts.title}</h1>

      <p data-testid="description" className="ProtectionPopup__text">
        {texts.description}
      </p>
    </div>
  );
};

type PopupText = {
  title: string;
  description: string;
};
const getPopupTexts = (
  status: ProtectionStatus,
  organisationName?: string
): PopupText => {
  switch (status) {
    case 'delegation_stopped':
      return getDelegationStoppedStatusText();
    case 'safe_network_delegated':
      return getSafeNetworkDelegatedStatusText(organisationName);
    default:
      return getProtectedStatusText();
  }
};

const getDelegationStoppedStatusText = (): PopupText => {
  return {
    title: t('School hours'),
    description: t(`Your school’s rules are protecting your device.`),
  };
};

const getSafeNetworkDelegatedStatusText = (
  organisationName?: string
): PopupText =>
  organisationName
    ? {
        title: t('Connected to a Safe Network'),
        description: t(
          `{{organisationName}}’s rules are protecting your device.`,
          {
            organisationName: organisationName,
          }
        ),
      }
    : {
        title: t('Connected to a Safe Network'),
        description: t(`Your school’s rules are protecting your device.`),
      };

const getProtectedStatusText = (): PopupText =>
  isDelegation
    ? getDelegationProtectedStatusText()
    : getFamilyProtectedStatusText();

const getFamilyProtectedStatusText = (): PopupText => {
  return {
    title: t('{{shortName}} is active', {
      shortName: t('Qustodio'),
    }),
    description: t(
      '{{shortName}} is working to protect and supervise this device.',
      {
        shortName: t('Qustodio'),
      }
    ),
  };
};

const getDelegationProtectedStatusText = (): PopupText => {
  return {
    title: t('Out of school hours'),
    description: t(
      'Rules set by your parent or guardian are protecting this device.'
    ),
  };
};

const getPopupIcon = (status: ProtectionStatus) =>
  status === 'delegation_stopped' || status === 'safe_network_delegated'
    ? school
    : shield;
